




























import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import dataStore from "@/store";
import PlushieStore from "@/modules/plushie/store";

import FactoryStore from "../../store";
import ProductionTimeNorm from "../../production-time-norm.model";

@Component({
  components: {
    LoadingSpinner,
  },
})
export default class ProductionTimeNormaViewForm extends Vue {
  @Prop({ required: true })
  public readonly factoryId!: string;

  @Prop({ default: true })
  public readonly showBackLink!: boolean;

  private fIsLoading = false;

  private fFactoryDataStore: FactoryStore;
  private fPlushieDataStore: PlushieStore;

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get timeNorms(): ProductionTimeNorm[] {
    const norms = this.fFactoryDataStore.getProductionTimeNormsByFactoryId(
      this.factoryId
    );

    const products = this.fPlushieDataStore.activeProductsList;

    const result: ProductionTimeNorm[] = [];

    products.forEach((product) => {
      const item = norms.find((value) => value.product === product.id);

      if (!item) {
        return;
      }

      result.push(item);
    });

    return result;
  }

  constructor() {
    super();
    this.fFactoryDataStore = getModule(FactoryStore, dataStore);
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  public getTimeNormProductName(timeNorm: ProductionTimeNorm): string {
    const product = this.fPlushieDataStore.getProductById(timeNorm.product);

    return product ? product.name : "";
  }

  public onBackClick(): void {
    this.$emit("back");
  }

  protected async created(): Promise<void> {
    this.fIsLoading = true;

    try {
      await Promise.all([
        this.fFactoryDataStore.loadProductionTimeNormsByFactoryId({
          factoryId: this.factoryId,
          useCache: false,
          isDisablePagination: true,
        }),
        this.fPlushieDataStore.loadProducts(),
      ]);
    } finally {
      this.fIsLoading = false;
    }
  }
}
